import FormField from "./FormField";
import Placeholder from "../../Placeholder";
import PropTypes from "prop-types";
import React, {useEffect} from "react";
import duckify from "../../../utils/duckify";
import {useFormikContext} from "formik";
import {sharedPortalHouseholds as households} from "../../../ducks";
import HouseholdField from "./HouseholdField";

const formatAddress = (household) =>
  [
    household.address_1,
    household.address_2,
    household.city,
    household.state,
    household.zip,
    household.country
  ].filter(v => v !== null && v !== undefined).join(", ")
;

/**
 * Select an existing household, or create a new one.
 */
const HouseholdIntakeField = ({editable, entity, label, households, duckMeta, required}) => {
  const {values, setValues} = useFormikContext();
  const selectOptions = households
    .map(household => ({label: formatAddress(household), value: household.id}))
    .concat({label: "Add a new address", value: '__new__'});
  const householdId = values[`${entity}_id`];
  const isEditable = householdId === "__new__" || householdId && editable(householdId);
  const ready = duckMeta.households.ready;

  // Update household form values when selection changes
  useEffect(() => {
    if (householdId) {
      const household = householdId === "__new__"
        ? {id: householdId}
        : households.find(h => h.id === householdId);

      if (household) {
        setValues({...values, [entity]: household});
      }
    }
  }, [householdId]);

  if (!ready) {
    return (<Placeholder.text/>);
  } else {
    return (
      <React.Fragment>
        <div className="sp-household-select row">
          <div className="col-12">
            {households.length !== 0 && (
              <FormField
                name={`${entity}_id`}
                label={label}
                type="select"
                options={selectOptions}
                required={required}
              />
            )}
          </div>
        </div>

        {isEditable && (<HouseholdField entity={entity} required={required} />)}
      </React.Fragment>
    );
  }
};

HouseholdIntakeField.defaultProps = {
  editable: (_householdId) => false,
  label: 'Household',
  required: false
}

HouseholdIntakeField.propTypes = {
  label: PropTypes.string,
  entity: PropTypes.string.isRequired,

  /* Function that takes a householdId and returns true if editable */
  editable: PropTypes.func,
  required: PropTypes.bool
};

const mapDucksToProps = () => ({households});

export default duckify(mapDucksToProps)(HouseholdIntakeField);
